import Vue from "vue";
import base from "../../../core/baseCore";

export default Object.assign(
    {
        apiUrl: "/account/",

        async getCampaignTree(establishmentId) {
            const url = this.url(`${establishmentId}/campaign/tree/`);
            return await Vue.http.get(url);
        },        
    },
    base
)
